import Icon from '../../generic/Icon';
import * as style from './Grape.module.css';

interface GrapeProps {
    grapeType: 'green' | 'blue';
    name?: string;
    summary?: string;
    slug?: string;
    listPage?: { path: string };
    synonyms?: string[];
    title?: 'h1' | 'h2';
}

export default function Grape({ grapeType, name, summary, slug, listPage, synonyms, title = 'h2' }: GrapeProps) {
    return (
        <>
            <span className={`${style.grapeType} ${style[grapeType]}`}>
                <Icon className="icon-grape" />
                {grapeType == 'blue' ? 'Blå drue' : 'Grønn drue'}
            </span>
            {title === 'h2' ? (
                <h2 className={style.title}>{!!slug && !!listPage ? <a href={`${listPage?.path}?id=${slug}`}>{name}</a> : name}</h2>
            ) : (
                <h1 className={style.title}>{name}</h1>
            )}

            {!!synonyms?.length && (
                <p className={style.synonyms}>
                    <span>Synonymer:</span>
                    {synonyms?.filter(Boolean).map((t) => (
                        <strong key={t}>{t}</strong>
                    ))}
                </p>
            )}
            {summary?.split('\n').map((t, i) => (
                <p key={i}>{t}</p>
            ))}
        </>
    );
}
